// Encart « Installer l'application » des paramètres sur téléphone : ce qu'il montre selon l'appareil.

export type Platform = "ios" | "android" | "other";

export type InstallState =
  | "hidden" // dans l'application elle-même, ou appareil sans moyen connu
  | "installed" // installée depuis ce navigateur : l'ouvrir depuis l'écran d'accueil
  | "prompt" // le navigateur permet un bouton d'installation
  | "android_steps" // Android sans bouton : passer par le menu du navigateur
  | "ios_steps"; // iPhone : aucun bouton possible, seulement le menu Partager

/** Un iPad récent se présente comme un Mac ; seul l'écran tactile le distingue. */
export const detectPlatform = (
  userAgent: string,
  maxTouchPoints: number,
): Platform => {
  if (/iPhone|iPad|iPod/.test(userAgent)) return "ios";
  if (/Macintosh/.test(userAgent) && maxTouchPoints > 1) return "ios";
  if (/Android/.test(userAgent)) return "android";
  return "other";
};

export const installState = ({
  standalone,
  platform,
  promptAvailable,
  installed,
}: {
  standalone: boolean;
  platform: Platform;
  promptAvailable: boolean;
  installed: boolean;
}): InstallState => {
  if (standalone) return "hidden";
  if (installed) return "installed";
  if (promptAvailable) return "prompt";
  if (platform === "ios") return "ios_steps";
  if (platform === "android") return "android_steps";
  return "hidden";
};
